import { formatPhoneNumber } from 'react-phone-number-input'
export const PhoneUtils = {
    format: (value) => {
        if (value != null && value.length > 0 && value.indexOf('tel:') === 0) {
            return formatPhoneNumber(value.substring('tel:'.length));
        } else {
            return value;
        }
    }
};